// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"453":"0541a85f","455":"52a515ca","977":"1b3f6f35"}[chunkId] + ".chunk.js";
};